/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { permissionsLlmGrant } from "../../funcs/permissionsLlmGrant.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.LlmGrantRequest$inboundSchema,
};

export const tool$permissionsLlmGrant: ToolDefinition<typeof args> = {
  name: "permissions-llm-grant",
  description: `Grant permission to a user or make public

Grant a role to a user for a resource, or grant public access by using "*" as userId. Only owners can grant permissions. Public access is allowed only for writer and reader roles.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await permissionsLlmGrant(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(void 0, apiCall);
  },
};
